import React from 'react'

const ErrorPage = () => (
        <h3 style={{color:'#003453',marginTop:'25%'}}>
            Error! The page is not available
        </h3>
)

export default ErrorPage;